import React from "react";
import { CircularProgress } from "@mui/material";

const SuspenseFallback = ({ from, bigSize, alignSelf, color }) => (
  <div
    style={{
      position: from ? "" : "fixed",
      top: from ? "0" : "40%",
      left: from ? "0" : "50%",
      alignSelf: alignSelf || "",
    }}
  >
    <CircularProgress size={bigSize ? bigSize : from ? 20 : 80} thickness={5} color={color} />
  </div>
);

export default SuspenseFallback;
